<template>
  <CRow style="min-height=50vh pb-5">
    <CCol sm="12" class="mb-4">
      <h2 class="subTitlePage font-weight-normal">
        {{ $t('audience.organize.header2.mach-columns') }}
      </h2>
    </CCol>

    <CCol sm="12" class="mb-4">
      <MenssageAlert :messages="messages" />
    </CCol>

    <CCol sm="12" v-if="this.notice" class="mt-5">
      <CRow>
        <CCol sm="12">
          <div class="box-upload-audience d-flex justify-content-center align-items-center mb-5 p-0" style="background-color: #edeff1; border: none">
            <span style="color: #7f889a"> {{ this.notice }}</span>
          </div>
        </CCol>
      </CRow>
    </CCol>

    <CCol sm="12" v-else>
      <div v-if="loading" class="box-upload-audience" style="background-color: #edeff1; border: none">
        <img src="img/site/creating.gif" style="max-width: 130px" class="" /><br />
        <span style="color: #7f889a">{{ $t('audience.organize.text.send-file') }}</span>
      </div>

      <CRow v-show="loading === false" :gutters="false">
        <transition-group name="fade" tag="div" class="col-sm-12" mode="out-in">
          <CRow v-show="display" class="p-3 fade-item" key="keyMainColumns">
            <MainColumns />
          </CRow>

          <CRow v-show="display" class="p-3 fade-item" key="keyAudienceList">
            <AudienceList v-if="audienceSummary" :payload="audienceSummary" :options="selectTypes" />
          </CRow>

          <CRow v-show="display" class="fade-item" :gutters="false" key="btnAdd">
            <CCol sm="12" md="7" class="mb-4">
              <CButton @click="addColumn" class="btn-block p-3 text-left text-white btn-gray-500 d-flex align-items-center" name="ADD MAIN COLUMN">
                <span class="mr-2">+</span>
                <span>{{ $t('audience.organize.button.add-main-column') }}</span>
              </CButton>
            </CCol>
          </CRow>

          <CRow v-show="display" class="fade-item" :gutters="false" key="tags">
            <CCol sm="12" md="4" class="mb-4 mt-4">
              <h3 class="font-weight-normal mb-4">{{ $t('audience.organize.header3.tag-audience') }}</h3>
              <p class="mb-2 font-weight-light text-uppercase text-value-sm">
                {{ $t('audience.organize.text.search-create') }}
              </p>
              <multiselect
                v-model="tags"
                class="border-gray-300"
                :tag-placeholder="$t('audience.organize.select.button.add-tag')"
                :placeholder="$t('audience.organize.select.placeholder.add-new-tag')"
                :options="tagsOptions"
                :multiple="true"
                :taggable="true"
                :show-labels="false"
                @tag="addTag"
              ></multiselect>
            </CCol>
          </CRow>

          <CRow v-show="display" class="fade-item my-5" :gutters="false" key="btnConfirm">
            <CCol sm="12" md="2">
              <CButton @click="submit()" :disabled="canConfirm" class="btn-primary btn-block py-3 px-5 font-weight-semi-bold">
                {{ $t('audience.organize.button.confirm') }}
              </CButton>
            </CCol>
          </CRow>
        </transition-group>
      </CRow>
    </CCol>
  </CRow>
</template>

<script>
import services from '@/services.js'
import { isEmpty } from '@/utils/utils.js'
import MainColumns from '../../components/organize/MainColumns '
import AudienceList from '../../components/organize/AudienceList'
import MenssageAlert from '@/components/MenssageAlert'

export default {
  name: 'AudienceOrganize',

  components: {
    MainColumns,
    AudienceList,
    MenssageAlert,
  },
  data() {
    return {
      loading: false,
      display: false,
      notice: '',
      messages: [],
      optionMainColumSelected: [],
      tags: [],
      tagsOptions: [],
    }
  },

  created() {
    this.loading = true
    this.notice = ''
    this.getData()
  },

  mounted() {
    this.tagsOptions = JSON.parse(JSON.stringify(this.audience.data.tags)) || []
  },

  beforeRouteLeave(to, from, next) {
    next(() => {
      localStorage.removeItem('audience')
      this.$store.dispatch('audience/clearSummary')
    })
  },

  methods: {
    noData() {
      if (isEmpty(this.audienceSummary)) {
        this.notice = "We don't have data yet, please choose a way to create your audience first."

        setTimeout(() => {
          this.$router.push({ name: 'choose-methods' })
        }, 3000)

        return
      }
    },

    addColumn() {
      this.$store.dispatch('audience/addColumn', {
        IsColumnInFile: false,
        new: true,
        fileColumnPosition: this.audienceSummary.length + 1,
        fileColumnName: '',
        isKey: false,
        edit: true,
        lines: [],
        type: null,
        state: { key: 1, value: 'UMAPPED' },
        messages: [{ key: 1, value: 'UMAPPED' }],
      })
    },

    getData() {
      this.noData()
      this.getSelectTypes()
    },

    getSelectTypes() {
      this.$store
        .dispatch('audience/getSelectTypes', this.organizationId)
        .then(() => {
          this.getDefaultFieldDataTypes()
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message,
          })
          this.noData()
        })
    },

    getDefaultFieldDataTypes() {
      this.$store
        .dispatch('audience/getDefaultFieldDataTypes', this.organizationId)
        .then((response) => {
          this.loading = !response
          this.display = response
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message,
          })
          this.noData()
        })
    },

    addTag(newTag) {
      this.tagsOptions.push(newTag)
      this.tags.push(newTag)
      this.$store.dispatch('audience/addTags', this.tagsOptions)
    },

    submit() {
      this.messages = []
      this.loading = true
      let nextPage = false

      const obj = {
        fileGuid: this.audience.data.fileGuid,
        phoneCountryIndicator: this.audience.data.phoneCountryIndicator,
        subscriptions: this.audience.data.subscriptions,
        Tags: this.tags,
        ImportSchema: this.treatSummary(),
      }

      services
        .sendForImport(this.organizationId, obj)
        .then((response) => {
          nextPage = response.data.success
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message,
          })
        })
        .finally(() => {
          if (nextPage) {
            this.$router.push({ name: 'complete' }).then(() => {
              this.$store.dispatch('audience/hasAudienceInProcess', this.organizationId)
            })
          }
          this.loading = false
        })
    },

    treatSummary() {
      const copy = JSON.parse(JSON.stringify(this.audienceSummary))

      return copy
        .filter((item) => item.state.value !== 'IGNORED')
        .map((element) => {
          delete element.edit
          delete element.lines
          delete element.messages
          delete element.new
          return element
        })
    },
  },

  computed: {
    canConfirm() {
      const noEdit = this.audienceSummary.some((item) => item.edit)
      const allIgnored = this.audienceSummary.every((item) => item.state.value == 'IGNORED')

      if (!this.hasAudience) {
        const hasMain = !this.audienceSummary.some((item) => item.isKey == true)
        return noEdit || allIgnored || hasMain
      }

      return noEdit || allIgnored
    },

    selectTypes() {
      return this.$store.getters['audience/selectTypes'] || []
    },

    audienceSummary() {
      return this.$store.getters['audience/audienceSummary']
    },

    audience() {
      return this.$store.state.audience.audienceSummary
    },

    hasAudience() {
      return this.$store.state.audience.hasAudience
    },

    organizationId() {
      return this.$store.state.auth.organizationId
    },
  },
}
</script>

<style lang="scss">
.exclamation {
  width: 20px;
  height: 20px;
  text-align: center;
  font-size: 12px;
  line-height: 20px;
  border-radius: 2px;
}

.modal-footer {
  border-top: 0;
}

@keyframes bounce {
  0% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes slide-in {
  from {
    transform: translateY(20px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-20px);
  }
}
</style>
